import Moment from 'moment';
import { useGlobalConst } from './constData';


export const parseJSON = (text) => {
  try {
    if (text && text !== "") {
      return JSON.parse(text);
    }
  } catch (error) { }
  return null;
};

export const getLocaleByLanguage = (language) => {
  if (language === "en") {
    return "en-GB";
  } else if (language === "vi") {
    return "vi-VN";
  } else {
    return "en-GB";
  }
};

export const priceToNumber = (strVal) => {
  if (typeof strVal === "number") {
    return strVal;
  }
  return Number((strVal ?? "").replace(/,/g, ""));
};

export const formatNumberPS = (num) => {
  //return (num).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return num && num !== null && num !== undefined ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
};

export const formatNumberPS_Price = (number) => {
  // Chuyển số thành chuỗi
  let numberString = number.toString();

  // Tách phần nguyên và phần thập phân
  let [integerPart, decimalPart] = numberString.split('.');

  // Định dạng phần nguyên với dấu phẩy
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Nếu có phần thập phân, ghép lại phần nguyên và phần thập phân
  if (decimalPart) {
    return `${integerPart}.${decimalPart}`;
  } else {
    return integerPart;
  }
}

export const formatNumberPS_AVGPrice = (number) => {
  // Làm tròn phần thập phân đến một chữ số
  const roundedNumber = number.toFixed(1);

  // Chuyển số đã làm tròn thành chuỗi
  let numberString = roundedNumber.toString();

  // Tách phần nguyên và phần thập phân
  let [integerPart, decimalPart] = numberString.split('.');

  // Định dạng phần nguyên với dấu phẩy
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Ghép lại phần nguyên và phần thập phân
  return `${integerPart}.${decimalPart}`;
}


export const formatNumber = (numberValue, locale, options) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  //
  options = Object.assign(
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    options
  );

  if (typeof numberValue !== "number") {
    numberValue = Number(numberValue);
  }

  locale = locale && locale === "" ? "en" : locale;

  if (numberValue === 0) {
    return "";
  }

  return numberValue?.toLocaleString(getLocaleByLanguage(locale), options);
};

export const formatNumber_N1 = (numberValue, locale, options) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  //
  options = Object.assign(
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    options
  );

  if (typeof numberValue !== "number") {
    numberValue = Number(numberValue);
  }

  locale = locale && locale === "" ? "en" : locale;

  return numberValue?.toLocaleString(getLocaleByLanguage(locale), options);
};

export const formatNumberWithUnit = (numberValue, unit, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }

  if (typeof numberValue !== "number") {
    numberValue = Number(numberValue);
  }

  return formatNumber(numberValue / unit, locale);
};

export const formatNumberWithUnit_N1 = (numberValue, unit, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }

  if (typeof numberValue !== "number") {
    numberValue = Number(numberValue);
  }

  return formatNumber_N1(numberValue / unit, locale);
};

export const formatNumberToM = (numberValue, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  return formatNumberWithUnit(numberValue, 1000000, locale);
};

export const formatNumberToM_N1 = (numberValue, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  return formatNumberWithUnit_N1(numberValue, 1000000, locale);
};

export const formatNumberToB = (numberValue, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  return formatNumberWithUnit(numberValue, 1000000000, locale);
};

export const formatNumberToB_N1 = (numberValue, locale) => {
  if (
    isNaN(numberValue) === true ||
    numberValue === undefined ||
    numberValue === null
  ) {
    return "";
  }
  return formatNumberWithUnit_N1(numberValue, 1000000000, locale);
};

export const formatPrice = (value, locale, options) => {
  if (isNaN(value) === true || value === undefined || value === null) {
    return "";
  }

  if (typeof value !== "number") {
    value = Number(value);
  }

  return formatNumber(value / 1000, locale, options);
};

export const formatPrice_N1 = (value, locale, options) => {
  if (isNaN(value) === true || value === undefined || value === null) {
    return "";
  }

  if (typeof value !== "number") {
    value = Number(value);
  }

  return formatNumber_N1(value / 1000, locale, options);
};

export const formatQtty = (value, locale) => {
  if (isNaN(value) === true || value === undefined || value === null || Number(value) <= 0) {
    return "";
  }

  if (typeof value !== "number") {
    value = Number(value);
  }

  let _result = formatNumber(value, locale);
  if (_result && _result.length > 0) {
    _result = _result.substr(0, _result.length - 1);

    while (
      _result &&
      _result.length > 0 &&
      (_result[_result.length - 1] == "." || _result[_result.length - 1] == ",")
    ) {
      _result = _result.substr(0, _result.length - 1);
    }

    return _result;
  } else {
    return _result;
  }
};

export const formatQttyFull_emptyIsZezo = (value, locale) => {
  if (isNaN(value) === true || value === undefined || value === null) {
    return "0";
  }

  if (typeof value !== "number") {
    value = Number(value);
  }

  let _result = formatNumber(value, locale);
  if (_result && _result.length > 0) {
    while (
      _result &&
      _result.length > 0 &&
      (_result[_result.length - 1] == "." || _result[_result.length - 1] == ",")
    ) {
      _result = _result.substr(0, _result.length - 1);
    }

    return _result;
  } else {
    return "0";
  }
};

export const signNumber = (value) => {
  if (priceToNumber(value) > 0) {
    return "+" + value;
  }
  return value;
};

export const roundNumber = (num, scale) => {
  if (!("" + num).includes("e")) {
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    var arr = ("" + num).split("e");
    var sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +(
      Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
      "e-" +
      scale
    );
  }
};

export const shortenNumberAuto = (value, language, options) => {
  if (isNaN(value) || value === undefined || value === null) return "";
  //
  options = Object.assign(
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      showMark: true,
    },
    options
  );

  language = language && language === "" ? "en" : language;
  let _value = 0,
    _shortenMark = "";

  if (Math.abs(value) >= 1000000000) {
    _value = value / 1000000000;
    _shortenMark = language === "en" ? "B" : "Tỷ";
  } else if (Math.abs(value) >= 1000000) {
    _value = value / 1000000;
    _shortenMark = language === "en" ? "M" : "Tr";
  } else {
    _value = value;
  }
  //
  return (
    _value.toLocaleString(getLocaleByLanguage(language), options) +
    (options.showMark ? _shortenMark : "")
  );
};

export const shortenNumberAutoK = (value, language, options) => {
  if (isNaN(value) || value === undefined || value === null) return "";
  //
  options = Object.assign(
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      showMark: true,
    },
    options
  );

  language = language && language === "" ? "en" : language;
  let _value = 0,
    _shortenMark = "";

  if (Math.abs(value) >= 1000000) {
    return shortenNumberAuto(value, language, options);
  } else if (Math.abs(value) >= 1000) {
    _value = value / 1000;
    _shortenMark = language === "en" ? "K" : "N";
  } else {
    _value = value;
  }
  //
  return (
    _value.toLocaleString(getLocaleByLanguage(language), options) +
    (options.showMark ? _shortenMark : "")
  );
};

export const getShortenMark = (value, language) => {
  if (isNaN(value) || value === undefined || value === null) return "";

  let _shortenMark = "";

  if (Math.abs(value) >= 1000000000) {
    _shortenMark = language === "en" ? "B" : "Tỷ";
  } else if (Math.abs(value) >= 1000000) {
    _shortenMark = language === "en" ? "M" : "Tr";
  } else if (Math.abs(value) >= 1000) {
    _shortenMark = language === "en" ? "K" : "N";
  }

  return _shortenMark;
};

export const getColorByPrice = (price, ceilPrice, floorPrice, refPrice) => {
  if (price === refPrice) {
    return "clr-ref";
  } else if (price >= ceilPrice) {
    return "clr-ceil";
  } else if (price <= floorPrice) {
    return "clr-floor";
  } else if (price < refPrice) {
    return "clr-down";
  } else if (price > refPrice) {
    return "clr-up";
  } else {
    return "";
  }
};

export const getColorByIndex = (value, priorValue) => {
  if (value === priorValue) {
    return "clr-ref";
  } else if (value < priorValue) {
    return "clr-down";
  } else if (value > priorValue) {
    return "clr-up";
  } else {
    return "";
  }
};

export const camelCaseObject = (o) => {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = camelCaseObject(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      // if (o.hasOwnProperty(origKey)) {
      newKey = (
        origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
      ).toString();
      value = o[origKey];
      if (
        value instanceof Array ||
        (value !== null && value.constructor === Object)
      ) {
        value = camelCaseObject(value);
      }
      newO[newKey] = value;
      // }
    }
  }
  return newO;
};
// 

export const formatDateGMT7 = (dateString) => {
  const date = new Date(dateString);

  const dayOfWeek = date.toLocaleString('vi-VN', { weekday: 'long' });
  const day = date.getDate();
  const month = date.toLocaleString('vi-VN', { month: 'numeric' });
  const year = date.getFullYear();

  const formattedDate = `${dayOfWeek}, ${day} tháng ${month}, ${year}`;

  return formattedDate;

}

export const formataDate_DDMMYYYY = (date) => {
  try {
    return Moment(date).format("DD/MM/YYYY");
  } catch (error) {
    return "";
  }
}

export function isNullOrEmpty(value) {
  return value === null || value === undefined || value === "";
}

export function formatPctChangePrice(value) {
  // Chuyển chuỗi hoặc số sang số thực
  const num = parseFloat(value);
  
  // Kiểm tra nếu là số nguyên (ví dụ: 0.00 === 0)
  if (Number.isInteger(num)) {
    return num.toString(); // Trả về số nguyên dưới dạng chuỗi
  }

  return value.toString(); // Nếu không phải số nguyên, giữ nguyên giá trị ban đầu
}